"use client";

import { Core } from "@faire/design-tokens";
import { strictLocalize } from "@faire/web/common/localization";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1538))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.961Z
 */
export const Sort = createSVGIcon(
  <>
    <path
      d="M3.00011 9.53478L6.53564 5.99924L10.0712 9.53478"
      stroke="currentColor"
    />
    <path d="M6.5 6L6.5 17.5" stroke="currentColor" />
    <path
      d="M21.0712 13.9652L17.5356 17.5008L14.0001 13.9652"
      stroke="currentColor"
    />
    <path d="M17.5713 17.5L17.5713 6" stroke="currentColor" />
  </>,
  "Sort",
  {
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Sort",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  }
);
